import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=7f715b3d&scoped=true&"
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"
import style0 from "./mall.vue?vue&type=style&index=0&id=7f715b3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f715b3d",
  null
  
)

export default component.exports